import React, { useState } from "react";
import { Key } from "react-feather";
import { Box, Tooltip } from "@mui/material";
import SecretsModal from "../Modals/SecretsModal";

const SidebarSecretsButton = () => {
  const [showSecretsModal, setShowSecretsModal] = useState(false);

  const handleSecretsClick = () => {
    setShowSecretsModal(true);
  };

  return (
    <>
      <Tooltip
        title="Secrets"
        placement="right"
        arrow
        slotProps={{
          arrow: { sx: { color: "#546e7a" } },
          tooltip: {
            sx: {
              backgroundColor: "#546e7a",
              fontSize: "11px",
              padding: "6px 12px",
              borderRadius: "6px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            },
          },
        }}
      >
        <Box
          onClick={handleSecretsClick}
          data-testid="sidebar-secrets-button"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 32,
            height: 32,
            borderRadius: "6px",
            cursor: "pointer",
            color: "rgba(233, 236, 239, 0.7)",
            transition: "all 0.15s ease-in-out",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.1)",
              color: "#ffffff",
              transform: "scale(1.04)",
            },
          }}
        >
          <Key size={18} />
        </Box>
      </Tooltip>
      <SecretsModal
        isShown={showSecretsModal}
        onHide={() => setShowSecretsModal(false)}
      />
    </>
  );
};

export default SidebarSecretsButton;
